<template>
    <IconField iconPosition="right" class="w-full">
        <InputIcon class="menu_search_robots__icon pi pi-search" :class="{active: model.search.length}" @click="onSubmit" />
        <AdaptersAutoComplete
            v-model="model.search"
            :suggestions="suggestion"
            :delay="searchDelayLoadData"
            :minLength="searchLengthLoadData"
            :placeholder="$t('lang.robots.search_input_placeholder')"
            class="w-full"
            inputClass="p-input-sm w-full"
            @blur="onBlur"
            @complete="onComplete"
            @itemSelect="onSubmit"
            @keyup.enter="onSubmit"
            :pt="{
                item: {class: 'font-light'},
                input: {class: 'overflow-hidden text-overflow-ellipsis font-light', style: 'padding-right: 2.6rem'},
                loadingIcon: {class: 'hidden'},
            }"
        ></AdaptersAutoComplete>
    </IconField>
</template>

<script>
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import AdaptersAutoComplete from "../../adapters/AutoComplete.vue";
import RobotsApi from "../../../api/RobotsApi";

export default {
    name: "MenuTopSearchRobots",
    props: {
        domain: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            model: {
                search: '',
            },
            suggestion: [],
            // задержка при вводе в поисковую строку перед отправкой запроса
            searchDelayLoadData: 500,
            // кол-во символов, с которых идет запрос на подгрузку подсказок в поиске
            searchLengthLoadData: 4,
        }
    },
    mounted() {
        this.model.search = this.domain;
    },
    methods: {
        onBlur() {
            if (!this.model.search) {
                this.model.search = this.domain;
            }
        },
        onComplete() {
            RobotsApi
                .getSuggestion({domain: this.model.search})
                .then(response => this.suggestion = response);
        },
        onSubmit() {
            window.open(sprintf('/%s/robots/report?domain=%s', window.locale, this.model.search), '_self');
        }
    },
    components: {
        AdaptersAutoComplete,
        IconField,
        InputIcon,
    },
}
</script>

<style scoped>
.menu_search_robots__icon {
    color: #A4B1BE;
}
.menu_search_robots__icon.active {
    cursor: pointer;
    color: #88CC30;
}
</style>
